<script setup lang="ts">
import { ToccoModuleFieldsFragment } from '~/api/graphql/generated'
import { Link } from '~/types'
import { useSchemaToccoBase } from '~/composables/useSchemaToccoBase'

useNoCache()

const props = withDefaults(
  defineProps<{
    entity: ToccoModuleFieldsFragment
    breadcrumbs?: Link[]
  }>(),
  {
    breadcrumbs: () => [],
  },
)

// Add schema.org JSON-LD structured data
useSchemaToccoBase(props.entity, 'module')
</script>

<template>
  <ToccoBase :entity="entity" :breadcrumbs="breadcrumbs" />
</template>
